// extracted by mini-css-extract-plugin
export default {"notificationContainer":"NotificationContainer_notificationContainer__1iUtn"};